import { removeHTMLTags } from 'shared/utils';

export const hasEvacContent = (input: {
  evacContent: string;
  customEvac: boolean;
  hasEvacZones: boolean;
}): boolean => {
  const { evacContent, customEvac, hasEvacZones } = input;
  if (hasEvacZones) {
    return customEvac && Boolean(removeHTMLTags(evacContent ?? ''));
  }
  return Boolean(removeHTMLTags(evacContent ?? ''));
};
